import { useForm } from '../../../../../shared/form/useForm';
import { ISelectCardFormData } from '../types/ISelectCardFormData';
import { useSelectCardSchema } from './useSelectCardSchema';

export function useSelectCardForm(
	selectCardFormDefaultValues?: ISelectCardFormData,
) {
	const validationSchema = useSelectCardSchema();
	const form = useForm<ISelectCardFormData>({
		validationSchema,
		defaultValues: selectCardFormDefaultValues,
	});

	return form;
}
